<template>
    <div>
        <banet-modal-confirm
                @confirmNo="confirm(false)"
                @confirmYes="confirm(true)"
                :show="showConfirm"
                :showFooter="true"
                :title="translations.modal_confirm_title"
                :body="translations.label_confirm_client_delete">
        </banet-modal-confirm>
        <h2>{{ getTranslation('lbl_client_list_headline') }}</h2>
        <div class="panel-heading">
            <div class="row">
                <div class="col-md-4 col-sm-6">
                    <form id="search" style="position: relative; z-index: 0;">
                        <div class="input-group">
                            <span class="input-group-addon glyphicon glyphicon-search" aria-hidden="true"
                                  :title="getTranslation('lbl_search')"></span>
                            <input name="query" v-model="searchQuery"
                                   class="form-control" :placeholder="getTranslation('lbl_search')">
                            <span class="input-group-addon">
                                <button class="btn btn-default" @click.prevent="searchQuery = ''">
                                    <span class="glyphicon glyphicon-remove"></span>
                                </button>
                            </span>
                        </div>
                    </form>
                </div>

                <div class="col-md-8  col-sm-6">
                    <router-link to="/history/client" activeClass="active" tag="button"
                                 class="btn btn-primary pull-right" :title="getTranslation('lbl_history_deleted')"> <i
                            class="fa fa-history" aria-hidden="true"></i></router-link>
                    <router-link to="/clientcreate" activeClass="active" tag="button"
                                 class="btn btn-default pull-right"> {{
                        getTranslation('app_lbl_action_client_create') }}</router-link>
                </div>
            </div>
        </div>
        <banet-tablegrid
                :data="gridData"
                :columns="gridColumns"
                :filter-key="searchQuery"
                :actionCol="true"
                :editBtn="true"
                :unlockBtn="true"
                :deleteBtn="true"
                :viewBtn="true"
                :viewLink="'client'"
                :actionLink="'client/edit'"
                :history="'/history/client'"
                @delete="remove"
                @unlock="unlock">
        </banet-tablegrid>
    </div>
</template>

<script>
    import {translationMixin} from '../../../../Banet/mixins/translationMixin.js';
    import {alertMixin} from '../../../../Banet/mixins/alertMixin.js';
    import BanetModalConfirm from '../../../../Banet/errorsAndNotifications/BanetModalConfirm.vue';
    import BanetTablegrid from '../../../../Banet/components/BanetTablegrid.vue';
    export default {
        mixins: [ translationMixin, alertMixin ],
        data: function(){
            return {
                searchQuery: '',
                gridColumns: [],
                gridData: [],
                selected: {}
            }
        },
        components: {
            banetTablegrid: BanetTablegrid,
            banetModalConfirm: BanetModalConfirm
        },
        created: function(){
            this.$socket.emit('clientGetList');
        },
        watch: {
            translations: function() {
                this.gridColumns = [
                    { label: this.getTranslation('lbl_client_name'), value: 'clientName' },
                    { label: this.getTranslation('lbl_client_username'), value: 'username' },
                    { label: this.getTranslation('lbl_language'), value: 'language' },
                    { label: this.getTranslation('lbl_client_hotlineNumber'), value: 'hotlineNumber' },
                    { label: this.getTranslation('lbl_client_twilioAccountSid'), value: 'twilioAccountSid' },
                    { label: this.getTranslation('lbl_client_twilioAccountToken'), value: 'twilioAccountToken' },
                    { label: this.getTranslation('lbl_client_clientApiToken'), value: 'clientApiToken' },
                    { label: this.getTranslation('lbl_client_locked'), value: 'locked' },
                ]
            }
        },
        sockets: {
            clientList: function(clients){
                clients.forEach((client, i) => {
                    const user = client.user[0];
                    client.locked = this.isLocked(user) ? this.isLocked(user) : '';
                    console.log('LOCKED: ', client.locked);
                });
                this.gridData = clients;

            },
            clientChanged: function(){
                this.$socket.emit('clientGetList');
            },
            usersChanged: function(){
                this.$socket.emit('clientGetList');
            },
        },
        methods: {
            isLocked: function(user) {
                let d = new Date();
                let nowMs = parseInt(d.getTime());
                let failstamp = user.failstamp ? parseInt(user.failstamp) : null;
                // console.log('ISLOCKED: ', user);
                if(failstamp){
                    let lockEnd = failstamp + (5 * 60000);
                    const lockFor = lockEnd - nowMs;
                    if(lockFor > 0) {
                        // user locked for
                        const lockedFor = this.convertMs(lockFor);
                        const lockedTime = lockedFor.min + ':' + lockedFor.sec;
                        return (lockedTime);
                    } else {
                        return false;
                    }
                }
            },
            convertMs: function(ms){
                let min = (ms / 1000) / 60;
                let sec = (ms / 1000) % 60;
                min = Math.trunc(min);
                sec = Math.trunc(sec);
                if (sec < 10){
                    sec = "0" + sec;
                }
                return {min, sec};
            },
            remove: function(item){
                this.selected = item;
                this.showConfirm = true;
            },
            confirm: function(y){
                this.showConfirm = false;
                if(y){
                    this.delete();
                } else {
                    this.selected = {};
                    return false;
                }
            },
            delete: function(){
                this.$socket.emit('clientDelete', this.selected);
                this.selected = {};
            },
            unlock: function(item){
                const user = item.user[0];
                console.log('USER: ', user._id);
                this.$socket.emit('userUnlock', user._id);
                this.selected = {};
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Clients.vue?03e988f0